/* eslint-disable */

import React, { useState, useEffect } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Box,
  Grid,
  TextField,
  FormControl,
  Checkbox,
} from '@mui/material';
import Autocomplete from '@mui/material/Autocomplete';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import dayjs from 'dayjs';
import addCommas from '../../utils/functions/commas';
import api from '../../utils/functions/api';
import NotFound from '../../assets/images/NotFound.jpg';

function FinalConfirmationPopup({ open, onClose }) {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      PaperProps={{
        sx: {
          borderRadius: '15px',
          width: '400px',
        },
      }}
    >
      <DialogContent>
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            fontWeight: 'bold',
            fontSize: '24px',
            marginTop: '20px',
          }}
        >
          <CheckCircleOutlineIcon
            sx={{ fontSize: 90, color: 'green', marginBottom: '10px' }}
          />
          บันทึกสำเร็จ !
        </Box>
      </DialogContent>
      <DialogActions sx={{ display: 'flex', justifyContent: 'center' }}>
        <Box
          sx={{
            width: '25%',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            border: '1px solid',
            borderRadius: '9px',
            color: '#45A6F5',
            backgroundColor: 'transparent',
            '&:hover': {
              backgroundColor: '#E3F3FF',
            },
            margin: 'auto',
          }}
        >
          <Button onClick={onClose}>Close</Button>
        </Box>
      </DialogActions>
    </Dialog>
  );
}

function RejectReasonPopup({
  open,
  onClose,
  setFinalConfirmationOpen,
  onCloseDetailPopup,
  rowData,
}) {
  const [reasons, setReasons] = useState([]);
  const [otherReason, setOtherReason] = useState('');
  const [autoCompleteOpen, setAutoCompleteOpen] = useState(false); // State to control Autocomplete open state
  const reasonOptions = [
    'หลักฐานไม่ชัด',
    'หลักฐานไม่ถูกต้อง',
    'ยอดไม่ตรง',
    'อื่นๆ',
  ];

  useEffect(() => {
    if (open) {
      setReasons([]);
      setOtherReason('');
      setAutoCompleteOpen(false); // Reset Autocomplete open state when the popup is opened
    }
  }, [open]);

  const handleOtherReasonChange = (event) => {
    setOtherReason(event.target.value);
  };

  const handleConfirm = async () => {
    // Check if reasons are selected
    if (reasons.length === 0) {
      alert('กรุณาเลือกเหตุผล');
      return;
    }

    // Check if 'อื่นๆ' is selected and otherReason is not provided
    if (reasons.includes('อื่นๆ') && !otherReason.trim()) {
      alert('กรุณากรอกเหตุผล');
      return;
    }

    const data = {
      note_reject_array: reasons,
      note_reject_string: otherReason || ' ',
      upload_ref_id: rowData.upload_ref_id,
      payment_status: 'reject',
    };

    try {
      const response = await api.post(
        `${process.env.REACT_APP_APIHOST}/banktransfer/updatestatus`,
        data,
        { headers: { Authorization: 'your_token_here' } },
      );
    } catch (error) {
      console.error('Error:', error);
      alert('เกิดข้อผิดพลาดในการบันทึกข้อมูล');
    }

    // Close the popups
    setFinalConfirmationOpen(true);
    onCloseDetailPopup();
    onClose();
  };

  const isConfirmDisabled = () => {
    if (reasons.length === 0) {
      return true;
    }
    if (reasons.includes('อื่นๆ') && otherReason.trim() === '') {
      return true;
    }
    return false;
  };

  const handleAutocompleteChange = (event, newValue) => {
    setReasons(newValue);
    setAutoCompleteOpen(false); // Close the Autocomplete dropdown after selection
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      PaperProps={{
        sx: {
          borderRadius: '15px',
          width: '600px',
        },
      }}
    >
      <DialogTitle>ในกรณีที่ไม่อนุมัติ กรุณาเลือกเหตุผล</DialogTitle>
      <DialogContent>
        <FormControl fullWidth sx={{ marginBottom: '20px' }}>
          <Autocomplete
            multiple
            options={reasonOptions}
            disableCloseOnSelect
            value={reasons}
            size="small"
            onOpen={() => setAutoCompleteOpen(true)}
            onClose={() => setAutoCompleteOpen(false)}
            open={autoCompleteOpen} // Control the open state
            onChange={handleAutocompleteChange}
            renderInput={(params) => (
              <TextField {...params} label="เหตุผล" placeholder="เลือกเหตุผล" />
            )}
            renderOption={(props, option, { selected }) => (
              <li {...props}>
                <Checkbox style={{ marginRight: 8 }} checked={selected} />
                {option}
              </li>
            )}
          />
        </FormControl>
        {reasons.includes('อื่นๆ') && (
          <TextField
            fullWidth
            label="กรุณากรอกเหตุผล"
            multiline
            rows={4}
            variant="outlined"
            value={otherReason}
            onChange={handleOtherReasonChange}
          />
        )}
      </DialogContent>
      <DialogActions sx={{ display: 'flex', justifyContent: 'center' }}>
        <Button
          onClick={handleConfirm}
          variant="contained"
          disabled={isConfirmDisabled()}
          sx={{
            width: '100px',
            border: '1px solid',
            color: '#51D245',
            backgroundColor: 'transparent',
            '&:hover': {
              backgroundColor: 'rgba(81, 210, 69, 0.1)',
            },
          }}
        >
          ยืนยัน
        </Button>
        <Button
          onClick={onClose}
          variant="contained"
          sx={{
            width: '100px',
            border: '1px solid',
            color: '#FC3A3A',
            backgroundColor: 'transparent',
            '&:hover': {
              backgroundColor: 'rgba(252, 58, 58, 0.1)',
            },
          }}
        >
          ยกเลิก
        </Button>
      </DialogActions>
    </Dialog>
  );
}

function DetailPendingSuperAdminPopup({ open, onClose, rowData }) {
  const [finalConfirmationOpen, setFinalConfirmationOpen] = useState(false);
  const [rejectReasonPopupOpen, setRejectReasonPopupOpen] = useState(false);

  const approve = async (popupData) => {
    if (!popupData.upload_ref_id) {
      alert('ไม่พบ upload_ref_id');
      return;
    }

    const data = {
      upload_ref_id: popupData.upload_ref_id,
      payment_status: 'approve',
    };

    try {
      const response = await api.post(
        `${process.env.REACT_APP_APIHOST}/banktransfer/updatestatus`,
        data,
        { headers: { Authorization: 'your_token_here' } },
      );
    } catch (error) {
      console.error('Error:', error);
      alert('เกิดข้อผิดพลาดในการบันทึกข้อมูล');
    }

    onClose();
  };

  const handleApprove = () => {
    approve(rowData);
    setFinalConfirmationOpen(true); // Open the final confirmation popup
  };

  const handleReject = () => {
    setRejectReasonPopupOpen(true);
  };

  const handleFinalConfirmationOpen = () => {
    onClose(); // Close the DetailPendingSuperAdminPopup
    setFinalConfirmationOpen(true); // Open the final confirmation popup
  };

  const handleFinalConfirmationClose = () => {
    setFinalConfirmationOpen(false);
    window.location.reload();
  };

  const handleRejectReasonClose = () => {
    setRejectReasonPopupOpen(false);
  };

  return (
    <>
      <Dialog
        open={open}
        onClose={onClose}
        PaperProps={{
          sx: {
            borderRadius: '15px',
            width: '100%',
            maxWidth: '950px',
          },
        }}
      >
        <DialogActions sx={{ justifyContent: 'flex-end' }}>
          <IconButton onClick={onClose} sx={{ color: '#8B8888' }}>
            <CloseIcon />
          </IconButton>
        </DialogActions>
        <DialogTitle>
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              fontWeight: 'bold',
              fontSize: '20px',
            }}
          >
            รายละเอียดรายการรอดำเนินการ
          </Box>
        </DialogTitle>
        <DialogContent>
          {rowData && (
            <Grid
              container
              spacing={2}
              sx={{
                width: '100%',
                maxWidth: '1000px',
                marginTop: '20px',
                marginLeft: 'auto',
                marginRight: 'auto',
              }}
            >
              {/* Detail Fields */}
              <Grid item xs={6} sm={6} md={3}>
                <div>เลขอ้างอิงรายการชำระเงิน : </div>
              </Grid>
              <Grid item xs={6} sm={6} md={3.5}>
                <div style={{ wordBreak: 'break-all', whiteSpace: 'normal' }}>
                  {rowData.upload_ref_id || '-'}
                </div>
              </Grid>

              <Grid item xs={6} sm={6} md={2}>
                <div>ชื่อร้านค้า : </div>
              </Grid>
              <Grid item xs={6} sm={6} md={3.5}>
                <div style={{ wordBreak: 'break-all', whiteSpace: 'normal' }}>
                  {rowData.company_name || '-'}
                </div>
              </Grid>

              <Grid item xs={6} sm={6} md={3}>
                <div>เลขอ้างอิงรายการของร้านค้า : </div>
              </Grid>
              <Grid item xs={6} sm={6} md={3.5}>
                <div style={{ wordBreak: 'break-all', whiteSpace: 'normal' }}>
                  {rowData.order_id || '-'}
                </div>
              </Grid>

              <Grid item xs={6} sm={6} md={2}>
                <div>ธนาคาร : </div>
              </Grid>
              <Grid item xs={6} sm={6} md={3.5}>
                <div style={{ wordBreak: 'break-all', whiteSpace: 'normal' }}>
                  {rowData.bank || '-'}
                </div>
              </Grid>

              <Grid item xs={6} sm={6} md={3}>
                <div>วันที่ชำระเงิน : </div>
              </Grid>
              <Grid item xs={6} sm={6} md={3.5}>
                <div style={{ wordBreak: 'break-all', whiteSpace: 'normal' }}>
                  {rowData.date_pay
                    ? dayjs(rowData.date_pay, 'YYYYMMDD').format('DD-MM-YYYY')
                    : '-'}
                </div>
              </Grid>

              <Grid item xs={6} sm={6} md={2}>
                <div>เวลาที่ชำระเงิน : </div>
              </Grid>
              <Grid item xs={6} sm={6} md={3.5}>
                <div style={{ wordBreak: 'break-all', whiteSpace: 'normal' }}>
                  {rowData.time_pay
                    ? dayjs(rowData.time_pay, 'HHmm').format('HH:mm')
                    : '-'}{' '}
                  น.
                </div>
              </Grid>

              <Grid item xs={6} sm={6} md={3}>
                <div>จำนวนเงิน : </div>
              </Grid>
              <Grid item xs={6} sm={6} md={3.5}>
                <div style={{ wordBreak: 'break-all', whiteSpace: 'normal' }}>
                  {rowData.amount ? addCommas(rowData.amount) : '-'} บาท
                </div>
              </Grid>

              <Grid item xs={6} sm={6} md={2}>
                <div>จำนวนเงินทั้งสิ้น :</div>
              </Grid>
              <Grid item xs={6} sm={6} md={3.5}>
                <div style={{ wordBreak: 'break-all', whiteSpace: 'normal' }}>
                  {rowData.total_amount ? addCommas(rowData.total_amount) : '-'}{' '}
                  บาท
                </div>
              </Grid>

              <Grid item xs={6} sm={6} md={3}>
                <div>หลักฐาน : </div>
              </Grid>
              <Grid item xs={12}>
                <Grid container spacing={2}>
                  {rowData.image && rowData.image.length > 0 ? (
                    rowData.image.map((imageBase64, index) => (
                      <Grid item xs={12} sm={6} md={4} key={index}>
                        <img
                          src={`data:image/jpg;base64,${imageBase64}`}
                          alt={`evidence-${index}`}
                          style={{
                            width: '100%',
                            height: 'auto',
                            maxWidth: '400px',
                            maxHeight: '800px',
                            objectFit: 'cover',
                            borderRadius: '8px',
                            marginBottom: '50px',
                          }}
                        />
                      </Grid>
                    ))
                  ) : (
                    <Grid item xs={12}>
                      <img
                        src={NotFound}
                        alt="Not found"
                        style={{
                          width: '100%',
                          height: 'auto',
                          maxWidth: '400px',
                          maxHeight: '800px',
                          objectFit: 'cover',
                          borderRadius: '8px',
                          marginBottom: '50px',
                        }}
                      />
                    </Grid>
                  )}
                </Grid>
              </Grid>
            </Grid>
          )}

          <Box
            sx={{
              width: '100%',
              display: 'flex',
              justifyContent: 'right',
              gap: 2,
              marginTop: '40px',
              marginBottom: '40px',
              marginRight: '20px',
            }}
          >
            <Button
              onClick={handleApprove}
              sx={{
                width: '100px',
                border: '1px solid',
                color: '#51D245',
                backgroundColor: 'transparent',
                '&:hover': {
                  backgroundColor: 'rgba(81, 210, 69, 0.1)',
                },
              }}
            >
              อนุมัติ
            </Button>
            <Button
              onClick={handleReject}
              sx={{
                width: '100px',
                border: '1px solid',
                color: '#FC3A3A',
                backgroundColor: 'transparent',
                '&:hover': {
                  backgroundColor: 'rgba(252, 58, 58, 0.1)',
                },
              }}
            >
              ปฏิเสธ
            </Button>
          </Box>
        </DialogContent>
      </Dialog>

      {/* Reject Reason Popup */}
      <RejectReasonPopup
        open={rejectReasonPopupOpen}
        onClose={handleRejectReasonClose}
        setFinalConfirmationOpen={setFinalConfirmationOpen} // Pass the state setter to the RejectReasonPopup
        onCloseDetailPopup={onClose} // Pass the onClose function to RejectReasonPopup
        rowData={rowData} // Pass the rowData to RejectReasonPopup
      />

      {/* Final Confirmation Popup */}
      <FinalConfirmationPopup
        open={finalConfirmationOpen}
        onClose={handleFinalConfirmationClose}
      />
    </>
  );
}

export default DetailPendingSuperAdminPopup;
